

export default class {
    constructor($el) {
        this.$ = $el;
        this.slides = [];
        this.currentI = 0;
        this.$slides = $el.find('.-slides');
        this.$strip = this.$slides.find('.-strip');
        this.stripWidth = this.$strip.outerWidth();
        this.$foundSlides = this.$strip.find('.-slide');
        this.$foundSlides.each((i, el)=>{
            let slide = new TextSliderSlide($(el), this, i);
            this.slides.push(slide);
        });
        $el.find('.-dots .-centered .-dot').each((i, el)=>{
            this.slides[i].addDot($(el));
        });
        this.timeout = null;
        this.setTimeout();
    }
    setTimeout() {
        if (this.time !== null) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(()=>{
            this.cycle();
        }, 5000);
    }
    current() {
        return this.slides[this.currentI];
    }
    cycle() {
        let nextI = this.currentI + 1;
        // console.log('nextI', nextI, this.slides.length);
        if (nextI >= this.slides.length) {
            nextI -= this.slides.length;
            // console.log('in', nextI);
        }
        this.slides[nextI].makeCurrent();
    }
    moveTo(pos) {
        this.$slides.animate({scrollLeft:pos}, 200, 'swing');
    }
}



class TextSliderSlide {
    constructor($slide, master, i) {
        this.$slide = $slide;
        this.master = master;
        this.$dot = null;
        this.pos = i / master.$foundSlides.length;
        // console.log(i, master.$foundSlides.length, this.pos);
        this.i = i;
    }
    addDot($dot) {
        this.$dot = $dot;
        $dot.click(()=>{
            if (this.master.currentI !== this.i) {
                this.makeCurrent();
            }
        });
    }
    makeCurrent() {
        this.master.setTimeout();
        this.master.current().deselect();
        this.master.currentI = this.i;
        this.$dot.addClass('-current');
        this.master.moveTo(this.pos * this.master.$strip.outerWidth());
        // console.log('makeCurrent foo', this.pos, this.$slide[0]);
    }
    deselect() {
        this.$dot.removeClass('-current');
        // console.log('deselect', this.$dot[0]);
    }
}





// WEBPACK FOOTER //
// ./scripts/lib/TextSlider.js